<template>
    <div class="animated fadeIn">

        <b-form-group label="Дата заезда" label-cols="2">
            <div class="input-group">
                <v-date-picker
                    id="date_begin_iso"
                    mode='range'
                    v-model='date_range'
                    :state="validateState('date_range_start')"
                    :attributes="datepicker_attributes"
                >
                    <b-form-input
                        type="text"
                        id="date_range_start_input"
                        slot-scope="{ inputProps, inputEvents, isDragging }"
                        class="form-control form-date-picker"
                        readonly
                        :state="validateState('date_range_start')"
                        v-bind="inputProps"
                        v-on="inputEvents" />
                </v-date-picker>

                <button type="button" class="btn btn-primary " @click.pevent="onSetDate()"> <i class="fa fa-file-text-o"></i> Сформировать список</button>

                <button type="button" class="btn btn-primary " @click.pevent="_reportAgentCheckinsOld"> <i class="fa fa-print"></i> Распечатать (старый формат)</button>

                <button type="button" class="btn btn-primary " @click.pevent="_reportAgentCheckins"> <i class="fa fa-print"></i> Распечатать (новый формат)</button>

            </div>
        </b-form-group>

        <b-card v-if="reports.length">
            <ul>
                <li v-for="r in reports">
                    <a :href="r.report_url" target="_blank">{{r.report_title}}</a>
                </li>
            </ul>
        </b-card>

        <table class="table table-bordered table-hover">
            <tr>
                <th>№ п/п</th>
                <th>ID</th>
                <th>даты</th>
                <th>Объект/город</th>
                <th>Суммы</th>
                <th>Агент/Агентство</th>
                <th>Заказчик/Контакты/Комментарий к водителям</th>
            </tr>
            <tr v-for="v, i in vouchers">
                <td>
                    {{ i }}
                </td>
                <td>
                    <a  :href="$router.resolve({ path: '/agent/voucher/'+v.id }).href">{{v.id}}</a><br />
                    <small>{{ CONSTANTS.VOUCHER_STATE_NAMES[v.status_index] }}</small>
                    <template v-if="checkVoucherSums(v)">
                        <br /><span class="alert-danger small">суммы не сходятся</span>
                    </template>
                </td>
                <td> {{ printDate(v.date_begin_iso) }}<br>{{ printDate(v.date_end_iso) }}</td>
                <td>
                    <template v-if="v.hotel">
                        {{ v.hotel.title }}<br>
                    </template>
                    <template v-if="v.city">
                        <small>{{ v.city.title }}</small>
                    </template>
                </td>
                <td style="text-align: right;">
                    {{ formatPriceKop(v.summa_full) }}<br>
                    <template v-if="v.summa_discount">
                        <span class="text-danger">-{{ formatPriceKop(v.summa_discount)  }}</span>
                    </template>
                    <template v-else><span class="text-secondary">---</span></template><br>
                    {{ formatPriceKop(v.summa_ref_agency-v.summa_discount) }}
                </td>
                <td>
                    {{ v.user.surname }} {{ v.user.name_ }} {{ v.user.patro }}<br>
                    <template v-if="v.company">
                        {{ v.company.title }}
                    </template>
                </td>
                <td >
                    <template v-if="v.customer_id">
                        {{ v.customer.surname }} {{ v.customer.name }} {{ v.customer.patro }}<br>
                        {{ v.customer.email }} {{ v.customer.tel }}<br>
                    </template>
                    <template v-else>
                        {{ v.contact_name }}<br>
                        {{ v.contact_email }} {{ v.contact_phones }}<br>
                    </template>
                    {{ v.comments_for_drive }}
                </td>
            </tr>
        </table>

        WID=1aeac045-a749-4375-a643-d06a8a301873

    </div>
</template>

<script>
    import Vue from 'vue'
    import {ServerTable, Event} from 'vue-tables-2'
    import { functions } from '@/functions.js';
    import { functions_loaders } from '@/functions_loaders.js';
    import { functions_voucher } from '@/functions_voucher.js';
    import { functions_report } from '@/functions_report.js';
    Vue.use(ServerTable)
    import {CONSTANTS} from '@/constants';

    export default {
        name: 'NsbPanelCheckins',
        components: { ServerTable, Event },
        mixins: [functions, functions_loaders, functions_voucher, functions_report],
        data: function () {
            return {
                date_range:null,
            }
        },
        methods: {
            onSetDate: function () {
                this.resetVouchers().loadCheckins(this.date_range_start, this.date_range_end);
            },

            _reportAgentCheckins: function() {
                this.$validator.validateAll().then((result) => {
                    if (result) this.reportAgentCheckins(this.date_range_start, this.date_range_end);
                });
            },

            _reportAgentCheckinsOld: function() {
                this.$validator.validateAll().then((result) => {
                    if (result) this.reportAgentCheckinsOld(this.date_range_start, this.date_range_end);
                });
            },

        },
        computed: {
            date_range_start: function () {
                if (this.date_range !== null)
                    return new Date(this.date_range.start).toLocaleDateString()
                return null;
            },
            date_range_end: function () {
                if (this.date_range !== null)
                    return new Date(this.date_range.end).toLocaleDateString()
                return null;
            },
        },
        created: function() {
            Event.$on('vue-tables.loading', ()=>{ /* this.$eventHub.$emit('loading_start'); */ });
            Event.$on('vue-tables.loaded',()=>{ /*this.$eventHub.$emit('loading_end'); */ });
            this.loadCheckins(this.date_range_start);
        }
    }
</script>
